import React, { useState } from 'react';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography
} from '@mui/material';
import {
  Face as FaceIcon,
  PersonAdd as PersonAddIcon,
  Search as SearchIcon,
  MoreVert as MoreVertIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import ReferencePersonDialog from './ReferencePersonDialog';
import SingleImageFaceRecognitionDialog from './SingleImageFaceRecognitionDialog';
import faceRecognitionService from '../services/faceRecognitionService';

/**
 * Component to add face recognition features to image actions
 */
const FaceRecognitionMenu = ({ image, sessionId, onReferencePersonAdded, onSuccess }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [referenceDialog, setReferenceDialog] = useState({ open: false });
  const [singleImageDialog, setSingleImageDialog] = useState({ open: false });
  const [loading, setLoading] = useState(false);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSetReferencePerson = () => {
    setReferenceDialog({ open: true });
    handleCloseMenu();
  };

  const handleReferenceDialogClose = () => {
    setReferenceDialog({ open: false });
  };

  const handleReferencePersonSuccess = (result) => {
    // Handle successful reference person setting
    console.log('Reference person set successfully:', result);
    
    // Notify parent component to refresh reference persons list
    if (onReferencePersonAdded) {
      onReferencePersonAdded(result);
    }
  };

  const handleFindMatchesInImage = () => {
    setSingleImageDialog({ open: true });
    handleCloseMenu();
  };

  const handleSingleImageDialogClose = () => {
    setSingleImageDialog({ open: false });
  };

  return (
    <>
      <IconButton 
        aria-label="face recognition options" 
        onClick={handleOpenMenu}
        size="small"
        color="primary"
      >
        <FaceIcon fontSize="small" />
      </IconButton>

      {/* Main Face Recognition Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <Typography variant="subtitle2" sx={{ px: 2, py: 1, color: 'text.secondary' }}>
          Face Recognition
        </Typography>
        <Divider />
        
        <MenuItem onClick={handleSetReferencePerson}>
          <ListItemIcon>
            <PersonAddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Tag Person in This Photo</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={handleFindMatchesInImage} disabled={loading}>
          <ListItemIcon>
            <SearchIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Find Matches in This Image</ListItemText>
        </MenuItem>

        <Divider />
        <MenuItem onClick={handleCloseMenu}>
          <ListItemIcon>
            <InfoIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>About Face Recognition</ListItemText>
        </MenuItem>
      </Menu>

      {/* Reference Persons Selection Menu */}
      {/* Removed - no longer needed for single image search */}

      {/* Set Reference Person Dialog */}
      <ReferencePersonDialog 
        open={referenceDialog.open} 
        onClose={handleReferenceDialogClose}
        sessionId={sessionId}
        image={image}
        onSuccess={handleReferencePersonSuccess}
      />

      {/* Single Image Face Recognition Dialog */}
      <SingleImageFaceRecognitionDialog
        open={singleImageDialog.open}
        onClose={handleSingleImageDialogClose}
        sessionId={sessionId}
        image={image}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default FaceRecognitionMenu;
